/**
 * (3022) Shared size for the flags shown in the Numbers and Users tables.
 * The ratio it asks for cannot be expressed through CountryFlag's `size` prop,
 * which locks width to 1.5x the height.
 *
 * Both tables render the flag inside a flex row, which shrinks it below its
 * set width on a narrow column, so the size is pinned rather than left to flex.
 */
export const tableFlagStyle = {
    width: '23px',
    minWidth: '23px',
    height: '15px',
    flexShrink: 0,
};
